<template>
   
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input type="password" v-model="ruleForm.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="ruleForm.newPassword" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="再输一次新密码" prop="checkNewPassword">
          <el-input type="password" v-model="ruleForm.checkNewPassword" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submitForm()">提交</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
   
</template>
<script>
import md5 from 'js-md5';
export default {
    data() {
 
      return {
        rules: {
          oldPassword: [
            {
              required: true,
              message: "请输入原密码",
              trigger: "blur"
            }
          ],
          newPassword: [
            {
              required: true,
              message: "请输入新密码",
              trigger: "blur"
            }
          ],
          checkNewPassword: [{validator:(rule,value,callback)=>{
                if(value == ""){
                    callback(new Error("请再输入一遍密码"));
                }else{
                    if(this.ruleForm.newPassword!=this.ruleForm.checkNewPassword){
                      callback(new Error("两次输入的新密码不一样"));
                    } else {
                       callback();
                    }
                }
            }, trigger:'blur'}]

        },
        ruleForm: {
            oldPassword:'',
            newPassword: '',
            checkNewPassword: ''
        }
        
      };
    },
    methods: {
      resetForm(){
        this.ruleForm.oldPassword = "";
        this.ruleForm.newPassword = "";
        this.ruleForm.checkNewPassword = "";
      },
      submitForm() {
              this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.$api.post('/backstage/admin/modifyPassword', 
                      {"oldPassword": md5(this.ruleForm.oldPassword),"newPassword":md5(this.ruleForm.newPassword)}, r => {
                      if(r.status == 0) {
                          alert("修改成功！");
                          this.$parent.$parent.closeModifyPassword() ;
                        } else {
                          alert(r.message);
                        }
                    });
                }
              }); 
      }
    } 
};
</script>
 



// WEBPACK FOOTER //
// src/views/modifyPassword.vue